import RegisterPostDocPage from './RegisterPostDocPage';
export default RegisterPostDocPage;
